import React, { useState, useEffect } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";
import { Moon, Clock } from "lucide-react";

export const QuietHoursCard = () => {
  const [prefs, setPrefs] = useState(null);

  useEffect(() => {
    (async () => {
      try { const { data } = await api.get("/notifications/preferences"); setPrefs(data); }
      catch (e) { console.error(e); /* non-blocking */ }
    })();
  }, []);

  const savePrefs = async (patch) => {
    setPrefs((p) => ({ ...(p || {}), ...patch }));
    try { const { data } = await api.patch("/notifications/preferences", patch); setPrefs(data); }
    catch (e) { toast.error("Could not save quiet hours"); }
  };

  return (
    <Card className="p-5 shadow-premium lg:col-span-1 h-fit" data-testid="quiet-hours-card">
      <div className="flex items-center gap-2 text-sm font-medium mb-1"><Moon className="h-4 w-4" />Quiet hours</div>
      <p className="text-[11px] text-muted-foreground mb-4">Mute alert sounds &amp; pop-ups overnight — alerts still land in your inbox.</p>
      <div className="flex items-center justify-between rounded-lg border p-3 mb-3">
        <div className="flex items-center gap-2">
          <Clock className="h-4 w-4 text-muted-foreground" />
          <div className="text-sm font-medium">Enable quiet hours</div>
        </div>
        <Switch checked={!!prefs?.quiet_hours_enabled} onCheckedChange={(v) => savePrefs({ quiet_hours_enabled: v })} disabled={!prefs} data-testid="quiet-hours-switch" />
      </div>
      <div className={`grid grid-cols-2 gap-3 transition-opacity ${prefs?.quiet_hours_enabled ? "" : "opacity-50 pointer-events-none"}`}>
        <div className="space-y-1.5">
          <Label className="text-xs">From</Label>
          <Input type="time" value={prefs?.quiet_hours_start || "22:00"} onChange={(e) => savePrefs({ quiet_hours_start: e.target.value })} data-testid="quiet-hours-start" />
        </div>
        <div className="space-y-1.5">
          <Label className="text-xs">To</Label>
          <Input type="time" value={prefs?.quiet_hours_end || "08:00"} onChange={(e) => savePrefs({ quiet_hours_end: e.target.value })} data-testid="quiet-hours-end" />
        </div>
      </div>
      {prefs?.quiet_hours_enabled && (
        <p className="text-[11px] text-muted-foreground mt-3" data-testid="quiet-hours-summary">
          Silenced between {prefs.quiet_hours_start} and {prefs.quiet_hours_end} (your local time).
        </p>
      )}
    </Card>
  );
};
